var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTshape(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 610.01 206.73",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.08
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.36,58.64S84.34,70.43,81.58,73s-12.85,11.78-15.45,14S56.26,95.44,53.7,97.53s-8.92,7.13-10.94,8.72-7.44,5.56-10.4,7.58-13.06,8.82-16.07,10.62-14.22,8.36-18.2,10.48-15.16,7.62-15.16,7.62l-4.67-18.42s2.94-1.44,4.54-2.24,9.41-5,11.2-6,3.84-2.13,4.11-2.3a1.49,1.49,0,0,1,.69-.26,2,2,0,0,1,.77-.61c.49-.22,1.69-1,2.63-1.51s6.17-3.71,8-4.87,7.78-5,8.19-5.35.54-.43.73-.43c0,0,0-.22.55-.48s2.11-1.54,3.12-2.22,6.25-4.39,8.1-5.74,5.28-4,6-4.45a6,6,0,0,1,1.06-.77,2.21,2.21,0,0,1,.81-.79c.56-.33,5.32-4.3,7-5.64s5.17-4.2,6.38-5.22,2.64-2.19,3-2.51.8-.69,1.43-1.29,6.71-6.14,7.89-7.2,3.23-2.89,3.81-3.48A18.06,18.06,0,0,1,70,59.22a7,7,0,0,0,1-.83c.27-.29.63-.68,1.06-1.11s4.29-4.11,5.24-5.1,5.41-5.73,5.41-5.73,2.32-1.42,5.7.32a15.22,15.22,0,0,1,7.09,6.83C97.14,57.09,96.36,58.64,96.36,58.64Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.78,48.43s-.3-1.17,1.64-3.1c1.4-1.39,5.76-5.85,6.12-6.24a2.27,2.27,0,0,1,1.07-.78A5.46,5.46,0,0,1,90.53,37a6.45,6.45,0,0,1,1.87-1.56,4.39,4.39,0,0,1,1.31-1.76c1.1-1,4.14-4.17,4.61-4.61a3.14,3.14,0,0,1,1.57-.73,7.13,7.13,0,0,1,5.66.83c2.78,1.78,6.06,4.21,7.71,7.93,1.17,2.62.89,3.67.71,4.43a4.73,4.73,0,0,1-1.18,2c-.66.73-3.87,4.19-4.47,4.82A5.2,5.2,0,0,1,107,49.4s-.16.24-.57.73a6.62,6.62,0,0,1-2.24,2.08L96.77,60a4.6,4.6,0,0,1-3.28,1.59",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.23,45.55s2.31-1.84,6.26-.08c2.66,1.18,6.93,3.75,8.48,9,1.07,3.61.1,5-.27,5.51",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.4,35.43A4.12,4.12,0,0,1,96,34.94,15,15,0,0,1,103.1,39,14.26,14.26,0,0,1,107,45.53a6.12,6.12,0,0,1,0,3.87",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.94,36.63a6,6,0,0,1,4.67-.43,19.24,19.24,0,0,1,6.55,4,16.29,16.29,0,0,1,3.49,5.48c.54,1.83,1.18,4.18-.87,6.17",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.84,37.92s1.1-1,4.32.16a13.25,13.25,0,0,1,6.63,4.35,13.67,13.67,0,0,1,3.49,5.82,5.06,5.06,0,0,1-.17,4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.33,37.21s2-1.41,5.78.29a18.33,18.33,0,0,1,6.3,4.69,11.46,11.46,0,0,1,2.75,4.91,6.58,6.58,0,0,1-.75,5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.51,33.89s1.88-1.42,5.52-.06a15.62,15.62,0,0,1,6.43,4.23,12.43,12.43,0,0,1,3.34,6.19c.45,1.89.41,2.84-1.11,4.69",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.81,34.74s1.14-1.22,4.56-.49a16.48,16.48,0,0,1,6.52,3.54,13.32,13.32,0,0,1,3.9,6.13c.58,2.54.34,3.84-.79,5.48",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.38,28.53s1.68-1.05,4.88,1.67c2.51,2.12,4.32,4.77,4.24,7.16",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.19,28.17s.77-1.78,3.87-1.57a10,10,0,0,1,7.23,3.7c2.09,2.26,4.17,3.81,4,8.38a2.34,2.34,0,0,1-1.13,2.13",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.82,28.35s.62-2,.72-2.44a1.94,1.94,0,0,1,.66-1c.36-.34,5.14-5.28,5.38-5.56s2-2.18,2.51-2.64,3-3.31,3.57-3.42a13.28,13.28,0,0,1,2.9-.15,18.81,18.81,0,0,1,4.1.63c1.17.39,1,.11,2.76,1.65a29.31,29.31,0,0,1,4.43,4.91c.81,1.26,1,1.53,1.13,1.8a1.43,1.43,0,0,1,.24.95,27,27,0,0,1-.44,3.21,7,7,0,0,1-.92,3c-.67.92-2.2,2.46-3.67,4S116,41,115.62,41.43s-.52.63-.93.65a7.35,7.35,0,0,1-.92,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.83,25.41a16.91,16.91,0,0,0,4.1,1c1.58.05,4,0,4,0a24.44,24.44,0,0,0,3.42,4.91A53.68,53.68,0,0,0,116.25,35s-.38,1.42-.76,3.29A20.78,20.78,0,0,0,115,42",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 116.25,
    y1: 34.99,
    x2: 128.18,
    y2: 22.58,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.95,
    y1: 26.37,
    x2: 120.86,
    y2: 14.21,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.11,41.94a4,4,0,0,1,1.86-2c3.74-1.67,14.74-6.69,15.1-6.84a2.27,2.27,0,0,1,2.05-.19,9.9,9.9,0,0,1,5,3.67,14.19,14.19,0,0,1,2.09,6.25,7.7,7.7,0,0,1-.93,4.26c-.33.51-.29.58-2.24,1.41s-13,5.88-13.61,6.13a6.12,6.12,0,0,1-2.88.23",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.23,33a7,7,0,0,1,1-2,4.16,4.16,0,0,1,1.8-1.13c1.07-.43,3.92-1.67,4.39-1.86a4.71,4.71,0,0,1,1.91-.4,40.52,40.52,0,0,1,4.55.1,3.4,3.4,0,0,1,1.8.8,17.84,17.84,0,0,1,2.73,3.83c1.2,2.16,1.89,3.57,1.89,5.13a12.53,12.53,0,0,1-.5,3.65,14.31,14.31,0,0,1-1.07,3c-.34.5-.27.61-1.32,1.09s-4.44,2-5.53,2.32A6,6,0,0,1,216,48c-.6.05-2.6,0-2.6,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.59,46.48s1.95,0,2.28-1.59a9.78,9.78,0,0,0-.36-6.69,11.55,11.55,0,0,0-4.37-5.68c-1-.55-2.67-1.43-3.76.37",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.68,30.8a16.76,16.76,0,0,0,3.49.21,26.43,26.43,0,0,0,3.58-.41c.71-.26,5.82-2.48,5.82-2.48",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.75,30.6a3.65,3.65,0,0,0-.21,3.15c.71,1.73,2.43,4.7,3.69,5.27a3,3,0,0,0,2.81-.13c1-.36,5.08-2.12,5.08-2.12",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.55,47.57a8.84,8.84,0,0,1,.06-4c.58-2,1.75-3.91,2.66-4.36",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 211.1,
    y1: 35.05,
    x2: 197.22,
    y2: 41.42,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.25,
    y1: 39.53,
    x2: 200.03,
    y2: 45.9,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.41,
    y1: 40.49,
    x2: 200.45,
    y2: 46.88,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 208.01,
    y1: 33.41,
    x2: 194.55,
    y2: 39.51,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 214.43,
    y1: 45.85,
    x2: 200.56,
    y2: 51.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.58,39.67a4.7,4.7,0,0,1,4.22.77c1.5,1.33,2.59,2.05,4,6.19a7.75,7.75,0,0,1,.29,5.45,3.49,3.49,0,0,1-2.25,2.67",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.8,53.25,156.8,74c-5,2.5-12.66,6.26-13.63,6.73s-2.36,1.22-5.11,2.63-14.33,7.32-15.67,7.92-1.87,1-2.81,1.47-1.07.46-2.24,1.07-14.62,7.3-16.52,8.21-2.46,1.23-3.42,1.71-9.82,4.88-12.4,6.24-20.78,10.85-24.42,12.74-28.29,13.91-30.22,14.95-11.42,5.61-16.63,8.08-8.79,4-14.16,6.27-12.85,5.52-12.85,5.52L-17,142.78s16.33-7.27,20.69-9.27S29,121.19,34.33,118.61c5.54-2.68,26.05-13.2,30.89-15.63s26.84-13.42,32.2-16,22.9-11.25,29.2-14.36S148,61.89,153.34,59.34s35.5-17.12,36.18-17.56,2.39-1.88,4.27-1.33c1.21.35,3.33,1.46,4.83,5.09C200.2,49.39,199.81,51.49,198.8,53.25Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.3,108.13S67.18,90,72.8,86s25-17.81,27-19.26,5.45-3.92,5.88-4.26.92-1.3,2-.83,3.28,1.16,6.56,5.71,3.62,5.74,4.07,9.2",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.49,62.6s-.38-1,1.14-2.13S126.12,45.71,128.33,44s20.1-15.42,23-17.65,10.81-8.29,11.16-8.53a1.24,1.24,0,0,1,1.44-.28A10.64,10.64,0,0,1,168.56,20,22.53,22.53,0,0,1,174.3,27c1.44,3.08,1.38,4.67,1.34,5.28a1.56,1.56,0,0,1-.59,1.32c-.46.4-39.7,30.5-40.93,31.5s-3.2,2.46-4.7,3.62-9.8,7.26-9.8,7.26",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.66,18.09s3.72-3,4-3.18.24-.31.85,0a26.65,26.65,0,0,1,3.15,2.22,27,27,0,0,1,2.2,2,9.79,9.79,0,0,1,1,1.41,35.69,35.69,0,0,1,2,3.76,18.56,18.56,0,0,1,.86,2.38c.08.42.11.6-.14.79s-1.32,1.08-2.38,1.86-1.67,1.34-1.67,1.34",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.38,14.88s.4-.62,1.43-.28,1.43.38,1.92.61a14.8,14.8,0,0,1,3.2,3,15.39,15.39,0,0,1,3,5c.43,1.67.5,2.56.36,2.76a2.59,2.59,0,0,1-.6.57",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.06,17c0,.2.09.37.41.65a28.74,28.74,0,0,0,2.59,2.28c1.32,1,3.28,2.35,3.28,2.35a8.58,8.58,0,0,0,.58,1.61,27.47,27.47,0,0,0,1.86,3.72c.68,1.09,1.25,1.94,1.25,1.94",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.34,
    y1: 22.26,
    x2: 176.26,
    y2: 19.93,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.25,15a1.87,1.87,0,0,1,.47-.79,1.31,1.31,0,0,0,.48-.45.7.7,0,0,1,.49-.38c.28-.06.21-.17.33-.33a1.43,1.43,0,0,1,.59-.32c.13-.05.17-.27.23-.4s.33-.16.53-.21.21-.18.34-.34a2.17,2.17,0,0,1,1-.34,3.22,3.22,0,0,1,2,.25,11.1,11.1,0,0,1,3.09,2.53,8.77,8.77,0,0,1,2.06,3.87c.2,1.41.15,1.94,0,2.27a1,1,0,0,1-.53.55,1,1,0,0,1-.88.81s0,.52-.76.62a1,1,0,0,1-.83.71,1,1,0,0,1-1,.67,1,1,0,0,1-.67.34",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.88,12a5.16,5.16,0,0,1,3.19,1.58,14.53,14.53,0,0,1,3.68,4.72,16.3,16.3,0,0,1,.75,2.51",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.83,12.82a6.8,6.8,0,0,1,3.37,1.69,12.37,12.37,0,0,1,3.31,4.15,12.72,12.72,0,0,1,.9,2.87",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.45,13.59a7.87,7.87,0,0,1,3.23,1.53,10.36,10.36,0,0,1,3.91,4.9,7,7,0,0,1,.55,2.43",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.32,14.41a6.16,6.16,0,0,1,3.44,1.44,11.91,11.91,0,0,1,3.58,4.41,7.74,7.74,0,0,1,.74,2.91",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 168.61,
    y1: 21.45,
    x2: 113,
    y2: 64.47,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 167.09,
    y1: 20.08,
    x2: 111.93,
    y2: 62.89,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 172.68,
    y1: 25.95,
    x2: 116.68,
    y2: 68.73,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 173.36,
    y1: 27.62,
    x2: 117.46,
    y2: 70.46,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 174.99,
    y1: 31.73,
    x2: 119.52,
    y2: 74.96,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-12,162.7l3.32,13.06s13-4.31,21.72-6.85,29.41-8.26,47.29-11.75c13.54-2.64,42.72-7.6,50.15-8.37s27.67-3.25,29-3.51,3.34-.36,5.79-.63,20.09-1.77,21.46-1.93,2.53-.32,3.92-.4,10.62-.87,15.77-1.24l12.09-.89c1.91-.15,4.35-.38,4.65-.18s1.27.71,1.69-.93a15.12,15.12,0,0,0,.45-5.81c-.2-2.91-.66-5.72-1.64-6.45a.87.87,0,0,0-1.43.28l-2.8.2c-1.57.11-13.05.75-13.86.84s-2.36.25-3.11.29-17.72,1.33-20.62,1.63-4,.38-5.47.55-2.16.27-2.78.28-3.44.19-7.3.6-7.71.74-12.33,1.28-7.18.73-8.31.94-3.24.4-4.39.53-15.22,1.81-19.39,2.49-6.64,1.06-8.31,1.27-17.39,2.72-22.87,3.62c-8.33,1.39-21.08,4.12-28,5.78s-23.43,5.73-32.62,8.44S-12,162.7-12,162.7Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.11,127.06a1.72,1.72,0,0,1,1.73-1.44c1.6-.13,10.21-.8,13-1s6.88-.32,7.6-.42c0,0,1.2,0,1.43.55m.89,14.53s.7,1.28.83,1.63.15.4.43.4,2.49-.07,3.08-.11.56-.19.9-.4a13,13,0,0,0,1.65-1.42,4,4,0,0,0,.53-.89,7.84,7.84,0,0,0,.31-1.42,58,58,0,0,0,0-6.38,16.29,16.29,0,0,0-.9-4.55,21.47,21.47,0,0,0-1.27-3c-.17-.42-.27-.54-.71-.49s-1.56,0-2.74.11a2.42,2.42,0,0,0-1.92,1c-.58.52-.83,1-1,1.19a17,17,0,0,1,1.13,2.81,19.42,19.42,0,0,1,.72,4.51A17.26,17.26,0,0,1,226.76,139.32Zm6.56.43s.81,0,1.16,0,.57-.19.84-.64a4.9,4.9,0,0,0,.59-1.32c.13-.41.29-.49.29-.49s.34.3.5.31a1.67,1.67,0,0,0,.47-.14c.27.7.84.34,1,.26a4.26,4.26,0,0,0,.42-.36,1.23,1.23,0,0,0,.12.47c.07.15.15.11.41,0a3.41,3.41,0,0,0,.57-.4c.22.5.31.41.51.38a1.9,1.9,0,0,0,.57-.4.81.81,0,0,1,.14.22.34.34,0,0,0,.45.13,3.24,3.24,0,0,0,.55-.47c.15.35.39.31.56.19s.28-.35.38-.4a.83.83,0,0,0,.54-.25,4.9,4.9,0,0,0,.88-2.51,18,18,0,0,0-.36-5.66,5.44,5.44,0,0,0-1.45-3.07c-.54-.51-.88-.2-.88-.2a3.75,3.75,0,0,0-.58-.27c-.22-.07-.7.18-.7.18a.76.76,0,0,0-.54-.12,2.08,2.08,0,0,0-.45.2.81.81,0,0,0-.55-.19,2.36,2.36,0,0,0-.61.23,1.17,1.17,0,0,0-.63-.17c-.22,0-.45.4-.45.4a.65.65,0,0,0-.4-.1c-.42,0-.31.38-.37.51s-.36.19-.63.16-.59-.89-1-1.59-.65-.64-.83-.63l-1.06.1",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.31,125.84a15.82,15.82,0,0,1,1,5.53,47.7,47.7,0,0,1-.18,5.91",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.21,123a27.34,27.34,0,0,0,.76,3c.44,1.26,1.59,3.62,1.59,3.62a29.65,29.65,0,0,0-.46,4.14,30.34,30.34,0,0,0,.18,5.31l-2.46,2.22",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.56,
    y1: 129.56,
    x2: 234.34,
    y2: 129.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 230.28,
    y1: 139.01,
    x2: 233.92,
    y2: 138.84,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.51,126.15a5.19,5.19,0,0,0,1.1,0c.33-.06.46.11.8,1.14a21.08,21.08,0,0,1,.86,5.73,18.81,18.81,0,0,1-.38,3.78c-.21.84-.32,1.22-.52,1.22l-.83.05a1.64,1.64,0,0,0-.4.1",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.42,
    y1: 132.2,
    x2: 206.3,
    y2: 133.11,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.39,
    y1: 133.33,
    x2: 206.47,
    y2: 134.35,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.77,
    y1: 127.91,
    x2: 205.9,
    y2: 129.19,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.38,
    y1: 126.65,
    x2: 205.64,
    y2: 128.14,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 227.12,
    y1: 136.89,
    x2: 206.19,
    y2: 138.25,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 226.69,
    y1: 138.15,
    x2: 205.95,
    y2: 139.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.25,126.07a11.8,11.8,0,0,1,1.47,5.61,25.64,25.64,0,0,1-.54,5.69",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.11,125.65a6,6,0,0,1,1.46,3c.52,2.09.88,6.33,0,8.83",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.25,125.43a3.61,3.61,0,0,1,1.09,1.73,15.17,15.17,0,0,1,1,4.87,17.91,17.91,0,0,1-.65,5.35",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.39,125.39a8,8,0,0,1,1.71,4.09,20.41,20.41,0,0,1,.18,5.65c-.18,1.05-.53,2.3-.53,2.3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.37,125.31s.75.4,1.31,2.18a19.15,19.15,0,0,1,.82,7.17,12.94,12.94,0,0,1-.6,2.6",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.83,148.54c4.24-1.7,22.93-9.25,29.09-11.48s27-9.63,33.64-11.72,27.15-8.15,32.13-9.41,28.75-6.85,37.13-8.5c10.06-2,33.63-5.67,39.59-6.45s7.55-1,8.34-1.11,2.35-.47,3.79-.62,8.5-.87,13.52-1.51S212.17,97,213,97a22.79,22.79,0,0,0,2.46-.2c1.07-.16,8.86-.79,10.65-1s12.11-.64,13.57-.67,2.4-.84,3.09-.7,2,.71,2.55,3.79.91,7.59-.06,10-1.43,3.17-2.2,2.9-.36-.56-2.21-.45-10.75.43-13,.7-11.2.91-15.4,1.39-6.87.63-9.63,1-13.77,1.73-18.72,2.49-6.13.79-7.44,1-19.6,3-23.17,3.79-22.07,4.38-25.74,5.19-23.55,5.75-26.73,6.61S72,141.48,72,141.48",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.12,112.52S91.4,109,97.83,107s30.22-9.54,36.1-11.59,39.62-13.92,40.13-14.2,1.08-1.61,2.5,0a22.13,22.13,0,0,1,4.5,7.82,31.48,31.48,0,0,1,1.62,8.39,1.54,1.54,0,0,1-2.1,1.62c-2.17.76-8.36,3-8.36,3",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.9,81.27s.11-1.09,2-1.76,10.2-4,14-5.39,7.13-2.76,7.87-3,2.12-.86,3.73,1.48a26,26,0,0,1,4,7.69c1.11,3.5,1.77,7.3,1.47,8.42s-.17,1.55-1.65,2.1-21.92,8.26-22.64,8.51a1.65,1.65,0,0,1-2.11-.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201,72l1.36-.59c.47-.2.53-.37,1.87.11,0,0,2.4,1.76,4.2,6.64s1.62,6.8,1.34,8c0,0-.33,1-.88,1.15s-1.78.75-1.78.75",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.16,71.41s9.4-3.83,10-4,.84-.25,1.64.5a22.67,22.67,0,0,1,3.7,6.69,16.93,16.93,0,0,1,1,7c-.13.88-.4.86-1.16,1s-9.53,3.68-9.53,3.68",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M214.27,67.34s.63-1.21.84-1.64a2.54,2.54,0,0,1,1.43-1c.66-.25,3.16-1.29,3.74-1.45a1.89,1.89,0,0,1,2,.84,23.22,23.22,0,0,1,4.09,7.62c1.53,4.57,1.61,7.4,1.51,8.47s-.15,1.43-1.06,1.77-3,1-3.54,1.24c-.74.27-1.73-.31-3.18-.95",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.82,65.18A8.92,8.92,0,0,1,219.71,69a28.28,28.28,0,0,1,3.38,10,11.66,11.66,0,0,1-.35,4.19",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.3,64.05a9.2,9.2,0,0,1,.52-2.56c.42-1,1.27-1.16,2.22-1.48s2.25-.84,2.75-1a2,2,0,0,1,2.09.31c.8.65,4.1,3.58,6.34,10.12,2.36,6.87,2.07,10.5,1.75,11.54s-.39,1.28-1,1.52-2.85,1.12-3.42,1.37a2.64,2.64,0,0,1-2.7-.07c-1-.75-1.48-1.22-1.48-1.22",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.94,71.22a8.62,8.62,0,0,1,2.87,3.38A48.05,48.05,0,0,1,209,83.17a7.11,7.11,0,0,1-.14,4.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.45,79.79s1.36.29,3,2.58a30.72,30.72,0,0,1,4.69,12.89c.52,3.7-.52,3.9-.52,3.9",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.99,
    y1: 76.06,
    x2: 180.39,
    y2: 84.73,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 202.7,
    y1: 75.22,
    x2: 180.02,
    y2: 83.9,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.58,
    y1: 83.28,
    x2: 182.78,
    y2: 91.5,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 205.7,
    y1: 84.09,
    x2: 183.16,
    y2: 92.32,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.9,60.46a7.06,7.06,0,0,1,3.59,2.61,22.77,22.77,0,0,1,4.22,8.06c1.46,4.2,2.17,8.66,1.89,10.41s-.67,2.5-1.25,2.54",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.27,94.84s.4-1.38,2.65-1.43,11.33-.62,12-.54,1.35.11,1.73.57a1.77,1.77,0,0,1,1.2.11s0-.65,1-.83a2.28,2.28,0,0,1,2.5.62s1.07-.24,1.44.06c0,0,.06-.81,1.2-.89s6.95-.37,7.44-.38A2.9,2.9,0,0,1,275,93.57s3.3,0,3.68,0,.5.08.89.53a2,2,0,0,0,1.26.68c.14,0,.8-.29,1.26,0a.88.88,0,0,1,.91-.06s.78-.28,1.16,0c0,0,.78-.28,1.08,0,0,0,.81-.31,1.08,0,0,0,.63-.31,1,0,0,0,.82-.33,1.28.1a.83.83,0,0,1,.89.19c.45.4.72.4,1,.67A5.25,5.25,0,0,1,291.66,98a13.2,13.2,0,0,1,.25,2.28,14.62,14.62,0,0,1-.26,3.92,3.93,3.93,0,0,1-.84,1.64c-.34.34-.52.63-.75.69a2,2,0,0,0-.65.42c-.17.14-.55.34-.75,0a4.21,4.21,0,0,1-.53.22.42.42,0,0,1-.55-.2,3.54,3.54,0,0,1-.61.24c-.23,0-.41,0-.47-.22a4,4,0,0,1-.59.32.58.58,0,0,1-.53-.11,5.16,5.16,0,0,1-.56.14.41.41,0,0,1-.47-.22,2.64,2.64,0,0,1-.53.22c-.22,0-.51,0-.61-.1a1.65,1.65,0,0,1-.37.18.67.67,0,0,1-.62-.1,3.81,3.81,0,0,1-.47.13c-.28,0-1.09.25-1.26.31a10.61,10.61,0,0,0-1.06.77,1.28,1.28,0,0,1-.82.38c-.31,0-1,0-1.17,0s-.23-.06-.35-.08a.76.76,0,0,0-.32.08,4.32,4.32,0,0,1-1,.08,7,7,0,0,1-1.08,1.37,4.5,4.5,0,0,1-1.91.4c-1,.07-5.91.18-6.48.22s-1.65.44-1.75-.65l-1.79.21a1.22,1.22,0,0,1-.95.57l-1.38.18A.49.49,0,0,1,260,111c-.07-.17-.22-.44-.43-.39a4.73,4.73,0,0,1-.73.1c-.21,0-.46-.15-.59,0a1.54,1.54,0,0,1-1.18.63c-.78,0-10.09.31-11.39.38s-1.82.15-2.18,0a10,10,0,0,1-1.34-1",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.69,93.52a12.73,12.73,0,0,1,2.39,5.76,21.13,21.13,0,0,1-.21,7.76,27.93,27.93,0,0,1-1.53,3.57",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.05,93.59a7.91,7.91,0,0,1,2.26,3.75,22.17,22.17,0,0,1,.27,9.89,7,7,0,0,1-1.86,3.41",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.44,93.4a13.35,13.35,0,0,1,2.41,6.85c.35,4.32-.08,6.19-.59,7.6a12.38,12.38,0,0,1-1.35,2.61",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264,93.44s2,1,2.59,5.3.28,7.58-.4,9.3a6.23,6.23,0,0,1-1.58,2.33",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,93.57a11.43,11.43,0,0,1,1.65,4.53,21.92,21.92,0,0,1,.14,6.83,30.74,30.74,0,0,1-1,4.1",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.77,94.36A5.87,5.87,0,0,1,281.36,97a18.9,18.9,0,0,1,.81,4.77c0,1.18-.16,4.49-1.89,6.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.87,94.8a12.29,12.29,0,0,1,1.58,5.88,12,12,0,0,1-1.32,6.37",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.09,94.86a11.19,11.19,0,0,1,1.45,4.75c.16,2.67-.36,6.16-1.19,7.5",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.11,94.94a14.45,14.45,0,0,1,1.48,5.83,17.17,17.17,0,0,1-1.12,6.14",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.25,94.82a15.73,15.73,0,0,1,1.4,5.84c0,2-.55,5.24-1.29,6.45",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.34,94.79a14.74,14.74,0,0,1,1.39,5.85,15.6,15.6,0,0,1-1.17,6.25",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.34,94.79a11.46,11.46,0,0,1,1.42,5.59,16.16,16.16,0,0,1-1.12,6.48",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.56,95a13.12,13.12,0,0,1,1.46,5.75,16.39,16.39,0,0,1-1.3,6.11",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.27,
    y1: 97.84,
    x2: 277.06,
    y2: 98.07,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 281.51,
    y1: 105.49,
    x2: 277.06,
    y2: 105.78,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.35,146.36s11.78-.59,13.56-.61,32.83.32,36.86.55,25.07,1.27,27.19,1.47S223,149.11,224,149.18s12.84,1.53,13.89,1.58,2.09-.29,2.92.94,2.55,3.49,1.89,8.74-2.28,8.46-4,9.54a3.49,3.49,0,0,1-3.52.31c-.76-.22-2.09-.34-3.33-.58a15.11,15.11,0,0,0-2.76-.3c-1.17-.06-7.47-.79-11.25-1.09s-12.17-1.13-12.17-1.13-42.36-2.66-58-2.38a281.21,281.21,0,0,0-36.27,2.84c-10.65,1.47-33.34,4.78-51.7,8.7a388.4,388.4,0,0,0-40.62,10.8c-11.57,3.67-22.68,7.23-22.68,7.23l-4.55-18",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.84,150.7a3.15,3.15,0,0,1,2.4-.77c.84.09,9.31,1.27,9.71,1.3a2.13,2.13,0,0,1,1.09.65,3.51,3.51,0,0,1,.39.57s.35-.32.63-.16c0,0,.21-.61,1.48-.46s2.93,0,3.83,1.54a1,1,0,0,1,.65-.08s0-1,2.55-.48,8.75,1.13,8.75,1.13a36.09,36.09,0,0,1,3.79-3.22c.76-.36.76-.41,3.49-.13,3.3.34,7.55.89,8.55,1a3.08,3.08,0,0,1,2.19,1,26.34,26.34,0,0,1,3.11,4.32,9.73,9.73,0,0,1,1.19,3,24.15,24.15,0,0,0,.42,3,10.61,10.61,0,0,1,.35,4.69,20,20,0,0,1-2,6.29c-1.22,2.41-1.74,3.81-2.27,4.26a49.29,49.29,0,0,1-3.91,3.08,5.7,5.7,0,0,1-3.78,1c-1.91-.19-8.67-.82-9.47-1a3.92,3.92,0,0,1-2.65-1.84c-.83-1.32-1.66-2.8-1.78-3.06s-.21-.67-.86-.71-6.69-1-7.38-1.06a6,6,0,0,1-2-.25,3,3,0,0,1-1.33-.92.85.85,0,0,0-.61-.09,1.55,1.55,0,0,0-.74.35c-.24.15-.67.21-1.66.09s-2.18-.12-2.9-1.19a5.58,5.58,0,0,1-1.14-.22,2.87,2.87,0,0,1-.77.62c-.21.1-.88,0-3.54-.44s-6-.85-6.8-1a3.45,3.45,0,0,1-2-1.26",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.48,152.46a20,20,0,0,1,1.49,10c-.68,5.06-2,6.87-5,9.84",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.16,152.35s3,3,2.3,10.05c-.63,6-3.24,8.48-5.3,10.06",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.68,173.67s4.54-3.16,5.23-10.36c.53-5.62-.5-9.68-2.81-11.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.35,153.44A18.51,18.51,0,0,1,259,163.51c-.73,7-4.66,9.73-4.66,9.73",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.42,152.89s4.23,3,3.08,11.16c-1,7.26-4.37,9.09-6.14,9.69",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.58,152.88s3.45,3,2.44,11.54a15,15,0,0,1-5.19,10.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.58,154s2.82.39,3.35,1a8,8,0,0,1,2.36,5.69c.17,3.57-.24,9.87-2.77,12.85s-3.2,2.66-4,2.53l-2.53-.36",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.49,150.54s-1.08.82,1.14,4.15,2.58,4.68,5.19,5,10.78,1.2,10.78,1.2",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.49,159.65c-1.41.32-2.07,1.14-2.49,2.73s-1.31,6.92-1.11,8.83.78,3.31,2.9,3.53,9.58,1.09,9.58,1.09",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,174.65A9.57,9.57,0,0,0,273.5,177c-2.07,1.81-3.57,2.71-3.1,4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.97,
    y1: 162.65,
    x2: 263.6,
    y2: 161.09,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.99,
    y1: 160.42,
    x2: 257.35,
    y2: 160.25,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.99,
    y1: 159.59,
    x2: 243.71,
    y2: 158.34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.97,
    y1: 163.65,
    x2: 263.5,
    y2: 162.04,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.05,
    y1: 161.32,
    x2: 257.21,
    y2: 161.03,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.88,
    y1: 160.46,
    x2: 243.77,
    y2: 159.25,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.5,
    y1: 171.06,
    x2: 261.97,
    y2: 169.55,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.34,
    y1: 168.86,
    x2: 255.93,
    y2: 168.66,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.33,
    y1: 167.89,
    x2: 242.22,
    y2: 166.35,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.15,
    y1: 171.99,
    x2: 261.7,
    y2: 170.45,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 256.99,
    y1: 169.72,
    x2: 255.59,
    y2: 169.49,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 250.72,
    y1: 168.8,
    x2: 241.85,
    y2: 167.19,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.29,
    y1: 155.7,
    x2: 261.8,
    y2: 154.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 273.72,
    y1: 156.43,
    x2: 262.21,
    y2: 154.66,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.23,
    y1: 153.49,
    x2: 255.75,
    y2: 153.28,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.64,
    y1: 154.14,
    x2: 256.24,
    y2: 153.91,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.1,
    y1: 152.45,
    x2: 242.17,
    y2: 151.28,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 251.46,
    y1: 153.2,
    x2: 242.63,
    y2: 152.08,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258,153.29s2.52,3.23,2,9.88c-.59,7.58-5.08,10.17-5.08,10.17",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.08,140s.3,1.08.89,1.05,20.78-1.26,21.27-1.28,1.23,0,1.52-.46",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.52,126.24a1.16,1.16,0,0,1,1.09-.23,2.42,2.42,0,0,1,1.42,1.53,20.14,20.14,0,0,1,1,5.56,21,21,0,0,1-.24,5.25,5.94,5.94,0,0,1-.75,1.94,1.21,1.21,0,0,1-1.65.36",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.19,150.47a2.57,2.57,0,0,1,2.17-.23,5.89,5.89,0,0,1,2.32,2.94,13.52,13.52,0,0,1,.95,5.24,24.55,24.55,0,0,1-1,6.26,12.83,12.83,0,0,1-1.85,4.42,4.7,4.7,0,0,1-2.64,2,3.47,3.47,0,0,1-2.35-.07",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.17,
    y1: 99.77,
    x2: 246.31,
    y2: 100.43,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.14,
    y1: 100.9,
    x2: 246.48,
    y2: 101.67,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.95,
    y1: 95.75,
    x2: 245.76,
    y2: 96.43,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.65,
    y1: 94.55,
    x2: 245.3,
    y2: 95.28,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.24,
    y1: 104.43,
    x2: 246.61,
    y2: 105.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.21,
    y1: 105.57,
    x2: 246.52,
    y2: 106.2,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 257.9,
    y1: 109.6,
    x2: 245.19,
    y2: 110.24,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 258.39,
    y1: 108.56,
    x2: 245.73,
    y2: 109.33,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTshape);
export default __webpack_public_path__ + "static/media/tshape.a0c145af9e92fd6c325085110d9f8a5c.svg";
export { ForwardRef as ReactComponent };